import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import TermsOfService from "@/pages/TermsOfService";

export const Route = createFileRoute("/terms-of-service")({
  component: TermsOfServiceRoute,
});

function TermsOfServiceRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <TermsOfService />
      </Suspense>
    </PageTransition>
  );
}
